import {
  FieldFunctionOptions,
  FieldMergeFunction,
  from,
  HttpLink,
} from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'

export const mergeEntities: FieldMergeFunction<
  any,
  any,
  FieldFunctionOptions<Record<string, any>, Record<string, any>>
> = (existing = [], incoming = [], { args }) => {
  if (args?.first === 1) return incoming

  const skip = args?.skip || 0

  if (skip === 0) return incoming

  const existingRefs = existing.map((item: { __ref: any }) => item.__ref)

  if (incoming.length)
    return existing.concat(
      incoming.filter(
        (row: { __ref: string }) => !existingRefs.includes(row.__ref)
      )
    )

  return existing
}

export const createRetryLink = (uri: string) =>
  from([
    new RetryLink({
      delay: {
        initial: 600,
        max: 1200,
      },
      attempts: {
        max: 3,
      },
    }),
    new HttpLink({
      uri,
    }),
  ])
